module.exports = __webpack_public_path__ + "img/level1_idle_mask.a61acddf.png";